<script>
/**
 * O vazio de uma seção do painel de detalhes.
 *
 * Desde a #1243 as seções não colapsam mais, então toda seção sem conteúdo
 * aparece na tela — e sem isto ela apareceria como um título solto, que lê
 * como bug. A moldura tracejada diz "aqui cabe alguma coisa" sem competir com
 * o conteúdo de verdade das seções vizinhas, e a ação (quando existe) fica
 * dentro dela: é o único lugar onde ela seria procurada.
 */
import PanelAddButton from './PanelAddButton.vue';

export default {
  components: { PanelAddButton },
  props: {
    message: {
      type: String,
      required: true,
    },
    // Sem rótulo, a caixa só informa. Nem todo vazio tem o que oferecer:
    // "Primeira conversa deste contato" não é algo que se resolva clicando.
    actionLabel: {
      type: String,
      default: '',
    },
  },
  methods: {
    onAction() {
      this.$emit('action');
    },
  },
};
</script>

<template>
  <div
    class="flex flex-col items-center w-full gap-1 px-4 py-4 text-center border border-dashed rounded-lg border-line-faint"
  >
    <p class="m-0 text-xs text-muted">{{ message }}</p>
    <!-- Mesmo botao dos outros "acrescentar" do painel, na forma de pilula: o
         vazio e onde a acao mais precisa parecer clicavel, e antes ela era um
         texto azul sem contorno -- a unica do painel que nao se parecia com um
         botao. Pontilhado dentro de moldura pontilhada nao confunde porque a
         moldura e da secao e a pilula tem fundo e altura proprios no hover. -->
    <PanelAddButton
      v-if="actionLabel"
      pill
      :label="actionLabel"
      @click="onAction"
    />
    <slot />
  </div>
</template>
